module.exports = __webpack_public_path__ + "img/logo_kurwio.bd793146.jpg";